import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=5c0538fc&scoped=true"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=5c0538fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0538fc",
  null
  
)

export default component.exports